import React, {useEffect, useState} from "react";
import {LabelInterface, ProductInterface} from "../../../interfaces/product/product.interface";
import Label from "./Label";
import {Skeleton} from "../utils/Skeleton";

interface ProductLabelsProps {
    product: ProductInterface;
}

const ProductLabels: React.FC<ProductLabelsProps> = ({ product }) => {
    const labels = product.labels;

    return (
        <div className="flex gap-[8px] mb-6 flex-wrap">
            {
                product.needUpdate ? <>
                    <Skeleton className="h-[40px] w-[200px]" />
                    <Skeleton className="h-[40px] w-[200px]" />
                </> :
                    ( labels?.map((label, i) => <Label key={ i } label={ label } />) )
            }
        </div>
    );
};

export default ProductLabels;